var clubProfileGroupsConfig = [
    {
        id: 'changeProfilePhoto-group',
        value: 'changeProfilePhoto-group',
        settingsGroupParams: [
            {
                id: 'changeClubProfilePhotoGroupParams',
                values: [
                    {
                        id: 'profilePhoto',
                        value: 'profilePhoto',
                        title: 'Фото клуба',
                        type: 'photo-upload',
                        dependentFields: ['name']
                    },
                ],
                type: 'accordion'
            },
        ]
    },
    {
        id: 'id-group',
        value: 'id-group',
        title: 'ID',
        settingsGroupParams: [
            {
                id: 'id-group',
                values: [
                    {
                        id: 'id',
                        value: 'id',
                        title: 'ID',
                        type: 'textField'
                    },
                ],
                type: 'accordion',
                editable: false
            },
        ]
    },
    {
        id: 'name-group',
        value: 'name-group',
        title: 'Название',
        settingsGroupParams: [
            {
                id: 'nameGroupParams',
                values: [
                    {
                        id: 'name',
                        value: 'name',
                        title: 'Название',
                        type: 'textField'
                    },
                ],
                type: 'accordion',
                editable: true
            },
        ]
    },
    {
        id: 'about-club',
        value: 'about-club',
        title: 'О клубе',
        settingsGroupParams: [
            {
                id: 'aboutClubGroupParams',
                values: [
                    {
                        id: 'about',
                        value: 'about',
                        title: 'О клубе',
                        type: 'textEditor',
                        textFieldIsMultiline: true
                    },
                ],
                type: 'accordion',
                editable: true
            },
        ]
    },
    {
        id: 'description-club',
        value: 'description-club',
        title: 'Информация',
        settingsGroupParams: [
            {
                id: 'descriptionClubGroupParams',
                values: [
                    {
                        id: 'description',
                        value: 'description',
                        title: 'Подробная информация',
                        type: 'textEditor',
                        textFieldIsMultiline: true
                    },
                ],
                type: 'accordion',
                editable: true
            },
        ]
    },
    {
        id: 'Url-SportClub',
        value: 'Url-SportClub',
        title: 'Уникальное имя для URL',
        settingsGroupParams: [
            {
                id: 'UrlSportClubGroupParams',
                values: [
                    {
                        id: 'url',
                        value: 'url',
                        title: 'Уникальное имя для URL',
                        type: 'textField',
                        textFieldIsMultiline: false
                    },
                ],
                type: 'accordion',
                editable: true
            },
        ]
    },
];
export default clubProfileGroupsConfig;
